import React from "react";

import Modal from "../../../utils/customModal";
import { loadingHtml, sucessInfoModal } from "../../../utils/functions";

const RenderContentModal = ({ title, children, buttons, loading }) => {
  return sucessInfoModal(title, children, buttons, loading);
};

export const SUCCESS_MESSAGE = 'Se actualizo correctamente pendiente de Aprobación.';

const RenderSuccessOrError = ({ loading, onOk, errors, onOkFail }) => (
  <RenderContentModal
    loading={loading}
    title={errors?.length ? "Error al editar cuenta" : "Edicion de cuenta"}
    buttons={{
      formBtn: { text: "Continuar", action: errors?.length ? onOkFail :  onOk },
    }}
  >
    {errors?.length ? (
      errors
    ) : (
      <p id="success-result">{SUCCESS_MESSAGE}</p>
    )}
  </RenderContentModal>
);

const LoadingAccountModal = ({ show, onOk, onOkFail, loading, errors = [] }) => {
  return (
    <Modal show={show}>
      {loading ? (
        loadingHtml()
      ) : (
        <RenderSuccessOrError onOkFail={onOkFail} errors={errors} onOk={onOk} loading={loading} />
      )}
    </Modal>
  );
};

export default LoadingAccountModal;
